module.exports = __webpack_public_path__ + "static/media/tapis.86ab2719.jpg";